// extracted by mini-css-extract-plugin
export default {"list__container":"list__container___tgbv1","list__content":"list__content___p9ASH","list__container-black":"list__container-black___Dt6bG"};